<div class="health-container">
  <img class="logo" src="assets/samsung-health/samsung-health-logo.png" />

  <div class="health-grid">
    <div class="health-block">
      <img src="assets/samsung-health/shoe-prints-solid.png" />
      <span class="value">6617</span>
      <span class="label">Steps</span>
    </div>

    <div class="health-block">
      <img src="assets/samsung-health/bed-front-solid.png" />
      <span class="value">7h12m</span>
      <span class="label">Sleep</span>
    </div>

    <div class="health-block">
      <img src="assets/samsung-health/fire-flame-curved-sh.png" />
      <span class="value">620</span>
      <span class="label">Calories</span>
    </div>

    <div class="health-block">
      <img src="assets/samsung-health/person-walking-solid.png" />
      <span class="value">4.71mi</span>
      <span class="label">Distance</span>
    </div>

    <div class="health-block">
      <img src="assets/samsung-health/heart-solid.png" />
      <span class="value">85</span>
      <span class="label">Latest</span>
    </div>

    <div class="health-block">
      <img src="assets/samsung-health/bed-pulse-solid.png" />
      <span class="value">56</span>
      <span class="label">Resting</span>
    </div>
  </div>
</div>
